export const T = {
  en_GB: {
    goal: "Goal",
    portfolio: "Portfolio",
    type: "Type",
    plannedMonth: "Planned month",
    netBuySell: "Net buy / sell",
    buy: "buy",
    sell: "sell",
    noGoal: "No goal",
    newAccount: "New account",
    model: "Model",
    custom: "Custom",
    dynamic: "Dynamic",
    expand: "Show portfolios",
    collapse: "Hide portfolios",
    conversionFailed: "Exchange rate missing — some amounts are left out",
  },
  nb_NO: {
    goal: "Mål",
    portfolio: "Portefølje",
    type: "Type",
    plannedMonth: "Planlagt måned",
    netBuySell: "Netto kjøp / salg",
    buy: "kjøp",
    sell: "salg",
    noGoal: "Uten mål",
    newAccount: "Ny konto",
    model: "Modell",
    custom: "Tilpasset",
    dynamic: "Dynamisk",
    expand: "Vis porteføljer",
    collapse: "Skjul porteføljer",
    conversionFailed: "Valutakurs mangler — noen beløp er utelatt",
  },
} as const;
